export interface LoadSize {
  id: string
  label: string
  description: string
  fill: number
}

export const loadSizes: LoadSize[] = [
  {
    id: 'single',
    label: 'Single Item',
    description: 'One couch, mattress, fridge or similar',
    fill: 12,
  },
  {
    id: 'quarter',
    label: 'Quarter Trailer',
    description: 'A small pickup bed worth of junk',
    fill: 25,
  },
  {
    id: 'half',
    label: 'Half Trailer',
    description: 'Half a garage, small remodel debris',
    fill: 50,
  },
  {
    id: 'three-quarter',
    label: '3/4 Trailer',
    description: 'Large garage or yard cleanup',
    fill: 75,
  },
  {
    id: 'full',
    label: 'Full Trailer',
    description: 'Full cleanout, estate or jobsite',
    fill: 100,
  },
]

export const jobTypes: string[] = [
  'Junk & debris',
  'Furniture',
  'Appliances',
  'Yard waste',
  'Construction debris',
  'Full cleanout',
]

export const timings: string[] = ['Today if possible', 'Tomorrow', 'This week', "I'm flexible"]
